import redirectUser from "helpers/redirectUser"
import useAuth from "hooks/useAuth"
import React from "react"
import { Navigate } from "react-router-dom"

function RedirectRouter() {
  const { userData } = useAuth()
  return <Navigate to={redirectUser(userData.user_type)} />
}

export default RedirectRouter
